module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zan-search",
    class: {
      'is-focus': _vm.isFocus
    }
  }, [_c('div', {
    staticClass: "zan-search__input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "refocus",
      rawName: "v-refocus",
      value: (_vm.focusStatus),
      expression: "focusStatus"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "focus": _vm.handleFocus,
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zan-icon zan-icon-close",
    on: {
      "click": _vm.handleClean
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zan-search__cancel",
    class: {
      'is-focus': _vm.isFocus
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("取消")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d1d3ca1!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/search/src/search.vue
// module id = 168
// module chunks = 0 2